export function header() {

    const path = location.pathname;

    // =====================================================================
    // ハンバーガーメニュー表示の処理
    // =====================================================================
    // document.addEventListener('DOMContentLoaded', () => {
    const header = document.querySelector('.j-header');
    const headerModal = document.querySelector('.j-headerModal');
    const headerBtns = document.querySelectorAll('.j-header_btn');
    const svgOpen = document.querySelector('.c-open-button-line-animation');
    const svgClose = document.querySelector('.c-close-button-line-animation');

    headerBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            const isOpen = header.classList.contains('is-open');

            header.classList.toggle('is-open', !isOpen);
            headerModal.classList.toggle('is-modalOpen', !isOpen);
            btn.classList.toggle('is-modalOpen', !isOpen);
            svgOpen?.classList.toggle('is-modalOpen', !isOpen);
            svgClose?.classList.toggle('is-modalOpen', !isOpen);
        });
    });

    // const header = document.querySelector('.j-header');
    const homeHeader = document.querySelector('.p-home_header');
    let lastScroll = window.pageYOffset;
    let manualScrollControl = true; // スクロールによる制御を許可するか

    // -------------------------------
    // TOPページのみ：IntersectionObserver
    // -------------------------------
    if (homeHeader) {
        // const observer = new IntersectionObserver(
        // (entries) => {
        //     entries.forEach(entry => {
        //     if (!entry.isIntersecting) {
        //         // .p-home_header が画面外に出たら表示
        //         header.classList.add('is-view');
        //         manualScrollControl = true; // スクロール制御有効化
        //     } else {
        //         // .p-home_header が画面内にある間は非表示
        //         header.classList.remove('is-view');
        //         manualScrollControl = false; // スクロール制御無効化
        //     }
        //     });
        // },
        // {
        //     root: null,
        //     threshold: 0
        // }
        // );

        // observer.observe(homeHeader);
    } else {

        let lastScroll = window.pageYOffset || document.documentElement.scrollTop;
        const header = document.querySelector('.j-header');
        let manualScrollControl = true; // TOPで強制制御する場合はこの変数を利用

        window.addEventListener('scroll', function () {
            if (!manualScrollControl) return;

            const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

            // 最上部にいるときは常に表示させる
            if (currentScroll <= 10) {
                header.classList.add('is-view');
            } else if (currentScroll < lastScroll) {
                // 上にスクロール中 → 表示
                header.classList.add('is-view');
            } else if (currentScroll > lastScroll) {
                // 下にスクロール中 → 非表示
                header.classList.remove('is-view');
            }

            lastScroll = currentScroll;
        });

    }

    // -------------------------------
    // 全ページ共通：スクロール方向で表示制御
    // -------------------------------


    // document.addEventListener("DOMContentLoaded", function () {
    //     const searchButton = document.querySelector(".l-header_search");
    //     const searchForm = document.querySelector(".l-header_search_form");

    //     searchButton.addEventListener("click", function () {
    //         const isVisible = searchForm.classList.toggle("is-visible");
    //         searchForm.style.display = isVisible ? "block" : "none";
    //         searchButton.setAttribute("aria-expanded", isVisible);
    //     });
    // });

    // =====================================================================
    // 検索窓周りの処理
    // =====================================================================
    document.addEventListener("DOMContentLoaded", () => {
    const searchWrappers = document.querySelectorAll(".j-search");

    searchWrappers.forEach(wrapper => {
        const searchBtn = wrapper.querySelector(".j-search_btn");
        const searchForm = wrapper.querySelector(".j-search_form");
        const input = searchForm.querySelector("input[name='s']");

        // トグル表示
        function toggleForm(e) {
        e.stopPropagation(); // ボタンクリック時に外部クリックとみなされないように
        const isOpen = searchForm.classList.contains("is-visible");

        if (!isOpen) {
            searchForm.classList.add("is-visible");
            input.focus();
        } else {
            searchForm.classList.remove("is-visible");
        }

        searchBtn.setAttribute("aria-expanded", !isOpen);
        }

        // 外部クリックで閉じる（この wrapper 外をクリックしたら）
        function closeFormIfOpen(e) {
        if (!wrapper.contains(e.target)) {
            searchForm.classList.remove("is-visible");
            searchBtn.setAttribute("aria-expanded", false);
        }
        }

        // ESCキーで閉じる
        function closeOnEsc(e) {
        if (e.key === "Escape") {
            searchForm.classList.remove("is-visible");
            searchBtn.setAttribute("aria-expanded", false);
        }
        }

        // 検索フォーム内クリックでも閉じないようにする
        searchForm.addEventListener("click", e => e.stopPropagation());

        // イベント登録
        searchBtn.addEventListener("click", toggleForm);
        document.addEventListener("click", closeFormIfOpen);
        document.addEventListener("keydown", closeOnEsc);
    });
    });

}